/**
 * Quels rayons et sous-rayons montrer dans le panneau « Rayons » du téléphone.
 *
 * Un rayon sans produit visible n'est pas proposé : « Consignes » et
 * « Surgelés » s'affichaient avec 0 article (25/09/2026), on tapait dessus et
 * on ne trouvait rien. Les nombres suivent déjà les filtres actifs (Notre
 * production, Anti-gaspi…), donc un rayon vidé par un filtre disparaît aussi.
 * Seule exception : le rayon (ou sous-rayon) où l'on SE TROUVE reste listé,
 * pour qu'on puisse toujours voir où l'on est et en sortir.
 */

interface CategorieMin {
  id: string;
  name: string;
  parent_id?: string | null;
}

export function rayonsVisibles<T extends CategorieMin>(
  categories: T[],
  nombres: Record<string, number>,
  rayonCourant: string | null,
): T[] {
  return categories.filter((c) => !c.parent_id && ((nombres[c.id] || 0) > 0 || c.id === rayonCourant));
}

export function sousRayonsVisibles<T extends CategorieMin>(
  categories: T[],
  rayonId: string,
  nombres: Record<string, number>,
  sousRayonCourant: string | null,
): T[] {
  return categories.filter(
    (c) => c.parent_id === rayonId && ((nombres[c.id] || 0) > 0 || c.id === sousRayonCourant),
  );
}
